module.exports = {
  title: '厂商联用户设置',
  route: {
    path: '/factory-trade-union',
    children: {
      path: 'factory-trade-form',
    },
  },
};
